import { Interpolation, Theme, css } from '@emotion/react'

export const wrapper: Interpolation<Theme> = (theme) => css`
  width: 100%;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: 0px 5px 7px -1px #8a94a621;

  display: flex;
  flex-direction: column;
`

export const chartWrapper: Interpolation<Theme> = css`
  position: relative;
  padding-left: 16px;
`

export const row: Interpolation<Theme> = (theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid ${theme.backgrounds.backgroundOne};
`

export const actions: Interpolation<Theme> = css`
  display: flex;
  gap: 8px;
`

export const badge: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const title: Interpolation<Theme> = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
`

export const dot: Interpolation<Theme> = (theme) => css`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${theme.colors.red};
`

export const button: Interpolation<Theme> = css`
  width: 29px;
  height: 29px;
  background: #e6eaef;

  :nth-of-type(1) {
    transform: rotate(180deg);
  }

  svg {
    color: #313949;
  }

  :disabled {
    background: #e6eaef;

    svg {
      color: #5a6c8a;
    }
  }
`

export const tooltipWrapper: Interpolation<Theme> = css`
  position: absolute;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  opacity: 0;
  z-index: 10;
`

export const tooltipInner: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #21252b;
  min-width: 162px;
  height: 38px;
  padding: 10px;
  border-radius: 10px;
`

export const tooltipArrow: Interpolation<Theme> = css`
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #21252b;
  border-radius: 20px;
  rotate: -90deg;
  margin-right: -8px;
`

export const tooltipText: Interpolation<Theme> = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  color: #ffffff;
`
